/**
 * Sidebar / route module keys aligned with login `accessedModules` from the admin API.
 */
export const AdminModuleKey = {
	USER_MANAGEMENT: "user management",
	PROPERTY_MANAGEMENT: "property management",
	EVENT_MANAGEMENT: "event management",
	PROPERTY_MARKETING: "property marketing",
	FNB_MANAGEMENT: "f&b management",
	BENEFICIARY_APPROVALS: "beneficiary approvals",
	ROLES_AND_PERMISSIONS: "roles and permissions",
	KERZNER_SUB_ADMIN: "kerzner sub admin management",
	APP_UPDATE: "app update",
	STATIC_CONTENT: "static content",
	CHARGES_MANAGEMENT: "charges management",
	REVENUE_MANAGEMENT: "revenue management",
	MONTHLY_STATEMENT: "monthly statement",
} as const;

export type AdminModuleKeyType =
	(typeof AdminModuleKey)[keyof typeof AdminModuleKey];

/** Backend `code` values from login `accessedModules`. */
export const AdminModuleCode = {
	USER_MANAGEMENT: "USER_MANAGEMENT",
	PROPERTY_MANAGEMENT: "PROPERTY_MANAGEMENT",
	EVENT_MANAGEMENT: "EVENT_MANAGEMENT",
	PROPERTY_MARKETING: "PROPERTY_MARKETING",
	FNB_MANAGEMENT: "FNB_MANAGEMENT",
	BENEFICIARY_APPROVALS: "BENEFICARY_APPROVALS",
	ROLES_PERMISSIONS: "ROLES_PERMISSIONS",
	KERZNER_SUB_ADMIN: "KERZNER_SUB_ADMIN_MANAGEMENT",
	APP_UPDATE: "APP_UPDATE",
	APP_UPDATES: "APP_UPDATES",
	STATIC_CONTENT: "STATIC_CONTENT",
	CHARGES_MANAGEMENT: "CHARGES_MANAGEMENT",
	CHARGE_MANAGEMENT: "CHARGE_MANAGEMENT",
	REVENUE_MANAGEMENT: "REVENUE_MANAGEMENT",
	MONTHLY_STATEMENT: "MONTHLY_STATEMENT",
} as const;

interface ModuleMatchConfig {
	key: AdminModuleKeyType;
	codes: string[];
	names: string[];
}

export const ADMIN_MODULE_MATCHERS: ModuleMatchConfig[] = [
	{
		key: AdminModuleKey.USER_MANAGEMENT,
		codes: [AdminModuleCode.USER_MANAGEMENT],
		names: ["user management", "pho user management"],
	},
	{
		key: AdminModuleKey.PROPERTY_MANAGEMENT,
		codes: [AdminModuleCode.PROPERTY_MANAGEMENT],
		names: ["property management"],
	},
	{
		key: AdminModuleKey.EVENT_MANAGEMENT,
		codes: [AdminModuleCode.EVENT_MANAGEMENT],
		names: ["event management"],
	},
	{
		key: AdminModuleKey.PROPERTY_MARKETING,
		codes: [AdminModuleCode.PROPERTY_MARKETING],
		names: ["property marketing"],
	},
	{
		key: AdminModuleKey.FNB_MANAGEMENT,
		codes: [AdminModuleCode.FNB_MANAGEMENT],
		names: ["f&b management", "f and b management", "fnb management"],
	},
	{
		key: AdminModuleKey.BENEFICIARY_APPROVALS,
		codes: [AdminModuleCode.BENEFICIARY_APPROVALS, "BENEFICIARY_APPROVALS"],
		names: ["beneficiary approvals"],
	},
	{
		key: AdminModuleKey.ROLES_AND_PERMISSIONS,
		codes: [AdminModuleCode.ROLES_PERMISSIONS],
		names: ["roles and permissions"],
	},
	{
		key: AdminModuleKey.KERZNER_SUB_ADMIN,
		codes: [AdminModuleCode.KERZNER_SUB_ADMIN],
		names: ["kerzner sub admin management"],
	},
	{
		key: AdminModuleKey.APP_UPDATE,
		codes: [AdminModuleCode.APP_UPDATE, AdminModuleCode.APP_UPDATES],
		names: ["app update", "app updates"],
	},
	{
		key: AdminModuleKey.STATIC_CONTENT,
		codes: [AdminModuleCode.STATIC_CONTENT],
		names: ["static content"],
	},
	{
		key: AdminModuleKey.CHARGES_MANAGEMENT,
		codes: [
			AdminModuleCode.CHARGE_MANAGEMENT,
			AdminModuleCode.CHARGES_MANAGEMENT,
		],
		names: ["charge management", "charges management"],
	},
	{
		key: AdminModuleKey.REVENUE_MANAGEMENT,
		codes: [AdminModuleCode.REVENUE_MANAGEMENT],
		names: ["revenue management"],
	},
	{
		key: AdminModuleKey.MONTHLY_STATEMENT,
		codes: [AdminModuleCode.MONTHLY_STATEMENT],
		names: ["monthly statement", "monthly statements"],
	},
];
